import React from 'react';
import LocalizedStrings from 'react-localization';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import imgPolis from '../img/polis_KASKO2.png';
import imgPolisWebp from '../img/polis_KASKO2.webp';
import car from '../img/car.svg';
import lamp from '../img/lamp.svg';
import family from '../img/family.svg';
import medical from '../img/medical.svg';
import police from '../img/police.svg';
import txt from '../img/txt.svg';
import witnesses from '../img/witnesses.svg';

function InsuranceTitle(props) {
  const strings = new LocalizedStrings({
    ru: {
      tab1: 'Что такое КАСКО',
      tab2: 'Как подобрать полис',
      tab3: 'Если случилось ДТП',
      tab4: 'Вопрос-ответ',
      title: 'Электронный полис КАСКО',
      txt: 'Это такой же полис, как и «традиционный» бумажный, только в электронном виде. С такой же правовой силой и стоимостью',
      list1: 'Рассчитайте точную стоимость на онлайн-калькуляторе',
      list2: 'Оформление КАСКО без похода в офис',
      list3: 'Страховой полис придет на электронную почту сразу после оплаты',
      btn: 'узнать стоимость',
      what_txt: 'КАСКО – это вид страхования вашего автомобиля от полного комплекса рисков либо их части. Обычно, включает такие риски, как угон, противоправные действия третьих лиц, пожар, ДТП и стихийные бедствия',
      how_txt: 'Быстро и удобно подобрать полис КАСКО вы можете на сайте POLIS.UA Мы предлагаем множество вариантов от разных страховых компаний и сотрудничаем только с лидерами рынка.',
      how_txt2: 'Как оформить договор КАСКО через POLIS.UA. Краткая инструкция',
      step: 'Шаг',
      step1: 'Определите рыночную стоимость автомобиля по гос. номеру либо введите данные об автомобиле',
      step2: 'Введите данные о водителе (кол-во водителей, возраст, стаж вождения и т.д.)',
      step3: 'Сравните предложения от страховых компаний',
      step4: 'Оформите заявку и получите полис',
      step_txt1: 'Включить «аварийку» и вызвать скорую помощь (если нужно)',
      step_txt2: 'Вы можете оформить "европротокол" или перейти к следующему шагу',
      step_txt3: 'Сообщить: представителю страховой компании, полиции, предупредить близких; записать контакты свидетелей',
      dtp_txt1: 'вызовите патрульную полицию и действуйте в соответствии с Правилами дорожного движения. Выполните фотографирование места происшествия и поврежденных транспортных средств. При оформлении ДТП сотрудниками полиции, сфотографируйте составленные ими документы: Схема ДТП (2 страницы), Админпротокол, прочее.',
      dtp_txt2: 'В случае наличия других участников и свидетелей ДТП,',
      dtp_txt3: 'зафиксируйте их данные (фамилия, адрес проживания, контактный телефон). Определите, застрахованы автомобиль или ответственность других участников ДТП и запишите данные о страховой компании.',
      dtp_txt4: 'В течение трех рабочих дней',
      dtp_txt5: 'с момента наступления страхового случая, Вам необходимо лично, курьером, по почте или по факсу передать в страховую компанию должным образом оформленное заявление о наступлении страхового события и справку уполномоченного органа. В случае повреждения только стеклянных деталей авто, предоставлять справку компетентных органов не обязательно. В случае наличия виновного другого лица, сообщите его данные представителю страховой компании.',
      dtp_txt6: 'Предоставьте поврежденное транспортное средство для осмотра представителю страховой компании и независимому эксперту. До получения согласия страховой компании не проводите никаких ремонтных работ поврежденного автомобиля.',
      dtp_txt7: 'В случае угона автомобиля',
      dtp_txt8: ', вместе с подачей заявления, Вам необходимо передать представителю страховой компании на временное хранение комплект ключей и свидетельство о регистрации этого авто (за исключением случаев, когда эти вещи были изъяты полицией или были похищены вместе с транспортным средством, о чем было заявлено в полицию).',
      faq_txt1: 'Если автомобиль по каким–либо причинам не прошел ТО, возможно ли заключить договор КАСКО?',
      faq_txt2: 'Да, Вы имеете право заключить договор КАСКО без прохождения ТО. Однако при наступлении страхового случая если Вы обратитесь в страховую компанию без техосмотра транспортного средства, то в выплате Вам будет отказано.',
      faq_txt3: 'В какие сроки страхователь обязан известить компанию после наступления страхового случая при Угоне или Ущербе автомобиля?',
      faq_txt4: 'При Угоне в течение суток с момента обнаружения. При ущербе – в любой страховой компании свои сроки, поэтому поинтересуйтесь именно у своего страховщика.',
      faq_txt5: 'Как восстановить полис КАСКО?',
      faq_txt6: 'При утере полиса КАСКО необходимо обратиться в страховую компанию, в который Вы его приобрели. Нужно будет написать заявление об утере, после чего страховая компания обязана выдать Вам новый полис. Причем в первый раз это делается абсолютно бесплатно.Та же самая процедура применима и для замены полиса КАСКО по причине смены данных водителя (смена фамилии и т.д.).',
      faq_txt7: 'Можно ли купить КАСКО без ОСАГО?',
      faq_txt8: 'Приобрести полис КАСКО без ОСАГО можно, поскольку КАСКО это добровольный вид страхования. Однако мы рекомендуем иметь оба полиса для полной защиты.',
      faq_txt9: 'Какие риски в КАСКО?',
      faq_txt10: 'Разные компании, на основании действующих в них правил КАСКО, включают в договора различные страховые риски. И если обобщить всю полученную информацию можно выделить следующие виды страховых рисков:',
      faq_txt11: 'Ущерб, в том числе и полное уничтожение.',
      faq_txt12: 'Хищение.',
      faq_txt13: 'Защита дополнительно установленного оборудования.',
      faq_txt14: 'Гражданская ответственность.',
      faq_txt15: 'Несчастный случай.',
      faq_txt16: 'Утрата товарной стоимости.',
      faq_txt17: 'GAP (разница между текущей стоимостью автомобиля и изначальной) Возникновение непредвиденных расходов.',
      faq_txt18: 'Что такое франшиза в КАСКО?',
      faq_txt19: 'Франшиза – это определенная часть ущерба по КАСКО, которую автовладелец возмещает самостоятельно при наступлении страхового случая. Зачастую размер данной франшизы – это фиксированная денежная сумма или процент от стоимости автомобиля.',
      faq_txt20: 'Что делать в случае наступления страхового события?',
      faq_txt21: 'В зависимости от вида произошедшего события, вызовите представителей соответствующей службы. Оставайтесь на месте происшествия и примите меры для недопущения увеличения размера ущерба или изменения обстоятельств происшествия. Если произошло возгорание или взрыв – ГСЧС Украины. В случае стихийного бедствия или нападения животных обратитесь в ГСЧС Украины или полицию. От представителей уполномоченных органов требуйте предоставления документов, подтверждающих факт наступления страхового события, а также описывающих причины и последствия страхового события.',
      faq_txt22: 'Какие лимиты по договору КАСКО?',
      faq_txt23: 'В зависимости от условий, которые выставляет СК',
      faq_txt24: 'В каком случае авто считается уничтоженным?',
      faq_txt25: 'Каждая страховая компания самостоятельно решает, в каких случаях можно признать конструктивную гибель автомобиля. Однако в правилах КАСКО большинства компаний указано, что тотальная гибель машины наступает в следующих случаях: - Если стоимость ремонта превышает определенный процент от страховой суммы (обычно 60-80 процентов). -  Если нет технической возможности отремонтировать автомобиль.',
    },
    ua: {
      tab1: 'Що таке КАСКО',
      tab2: 'Як підібрати поліс',
      tab3: 'Якщо трапилося ДТП',
      tab4: 'Питання-відповідь',
      title: 'Електронний поліс КАСКО',
      txt: 'Це такий же поліс, як і «традиційний» паперовий, тільки в електронному вигляді. З таким самим правовим силою і вартістю',
      list1: 'Розрахуйте точну вартість на онлайн-калькуляторі',
      list2: 'Оформлення КАСКО без походу в офіс',
      list3: 'Страховий поліс прийде на електронну пошту відразу після оплати',
      btn: 'дізнатися вартість',
      what_txt: 'КАСКО - це вид страхування вашого автомобіля від повного комплексу ризиків або їх частини. Зазвичай, включає такі ризики, як викрадення, протиправні дії третіх осіб, пожежа, ДТП та стихійні лиха',
      how_txt: 'Швидко і зручно підібрати поліс КАСКО ви можете на сайті POLIS.UA Ми пропонуємо безліч варіантів від різних страхових компаній і співпрацюємо тільки з лідерами ринку.',
      how_txt2: 'Як оформити договір КАСКО через POLIS.UA. Коротка інструкція',
      step: 'Крок',
      step1: 'Визначте ринкову вартість автомобіля по держ. номеру або введіть дані про автомобіль',
      step2: 'Введіть дані про водія (к-ть водіїв, вік, стаж водіння)',
      step3: 'Порівняйте пропозиції від страхових компаній',
      step4: 'Оформіть заявку і отримайте поліс',
      step_txt1: 'Включіть «аварійку» та визвіть швидку допомогу (якщо необхідно)',
      step_txt2: 'Ви можете оформити "європротокол" або перейти до наступного кроку',
      step_txt3: 'Повідомити: представнику страхової компанії, поліції, попередити близьких; записати контакти свідків',
      dtp_txt1: 'викличте патрульну поліцію і дійте відповідно до Правил дорожнього руху. Виконайте фотографування місця події та пошкоджених транспортних засобів. При оформленні ДТП співробітниками поліції, сфотографуйте складені ними документи: Схема ДТП (2 сторінки), Адмінпротокол, інше.',
      dtp_txt2: 'У разі наявності інших учасників і свідків ДТП,',
      dtp_txt3: 'зафіксуйте їх дані (прізвище, адреса проживання, контактний телефон). Визначте, чи застраховані автомобіль або відповідальність інших учасників ДТП і запишіть дані про страхову компанію.',
      dtp_txt4: 'Протягом трьох робочих днів',
      dtp_txt5: "з моменту настання страхового випадку, Вам необхідно особисто, кур'єром, поштою або по факсу передати в страхову компанію належним чином оформлену заяву про настання страхового випадку та довідку уповноваженого органу. У разі пошкодження тільки скляних деталей авто, надавати довідку компетентних органів не обов'язково. У разі наявності іншої винної особи, повідомте його дані представника страхової компанії.",
      dtp_txt6: 'Надайте пошкоджений транспортний засіб для огляду представнику страхової компанії і незалежному експерту. До отримання згоди страхової компанії не проводьте ніяких ремонтних робіт пошкодженого автомобіля.',
      dtp_txt7: 'У разі викрадення автомобіля',
      dtp_txt8: ', разом з поданням заяви, Вам необхідно передати представнику страхової компанії на тимчасове зберігання комплект ключів і свідоцтво про реєстрацію цього авто (за винятком випадків, коли ці речі були вилучені поліцією або були викрадені разом з транспортним засобом, про що було заявлено в поліцію).',
      faq_txt1: 'Якщо автомобіль з яких-небудь причин не пройшов ТО, чи можливо укласти договір КАСКО?',
      faq_txt2: 'Так, Ви маєте право укласти договір КАСКО без проходження ТО. Однак при настанні страхового випадку якщо Ви звернетеся в страхову компанію без техогляду транспортного засобу, то у виплаті Вам буде відмовлено',
      faq_txt3: "В які терміни страхувальник зобов'язаний сповістити компанію після настання страхового випадку при викраденні або збитку автомобіля?",
      faq_txt4: 'При викраденні протягом доби з моменту виявлення. При збитку - в будь-якій страховій компанії свої терміни, тому поцікавтеся саме у свого страховика.',
      faq_txt5: 'Як відновити поліс КАСКО?',
      faq_txt6: "При втраті поліса КАСКО необхідно звернутися в страхову компанію, в якій Ви його придбали. Потрібно буде написати заяву про втрату, після чого страхова компанія зобов'язана видати Вам новий поліс. Причому в перший раз це робиться абсолютно безкоштовно.Та ж сама процедура може бути застосована і для заміни поліса КАСКО через зміну даних водія (зміна прізвища, тощо).",
      faq_txt7: 'Чи можна купити КАСКО без ОСГПВ?',
      faq_txt8: 'Придбати поліс КАСКО без ОСГПВ можна, оскільки КАСКО це добровільний вид страхування. Однак ми рекомендуємо мати обидва поліса для повного захисту.',
      faq_txt9: 'Які ризики в КАСКО?',
      faq_txt10: 'Різні компанії, на підставі діючих в них правил КАСКО, включають до договору різні страхові ризики. І якщо узагальнити всю отриману інформацію можна виділити наступні види страхових ризиків:',
      faq_txt11: 'Збиток, в тому числі і повне знищення.',
      faq_txt12: 'Розкрадання.',
      faq_txt13: 'Захист додатково встановленого обладнання.',
      faq_txt14: 'Громадянська відповідальність.',
      faq_txt15: 'Нещасний випадок.',
      faq_txt16: 'Втрата товарної вартості.',
      faq_txt17: 'GAP (різниця між поточною вартістю автомобіля та початкової)Виникнення непередбачених витрат.',
      faq_txt18: 'Що таке франшиза в КАСКО?',
      faq_txt19: 'Франшиза - це певна частина збитку по КАСКО, яку автовласник відшкодовує самостійно при настанні страхового випадку. Найчастіше розмір даної франшизи - це фіксована грошова сума або відсоток від вартості автомобіля.',
      faq_txt20: 'Що робити в разі настання страхової події?',
      faq_txt21: 'Залежно від виду події, що сталася, викличте представників відповідної служби. Залишайтеся на місці події і прийміть заходи для недопущення збільшення розміру збитку або зміни обставин події.У разі виникнення пожежі або вибух - ДСНС України. У разі стихійного лиха або нападу тварин зверніться в ДСНС України або поліцію. Від представників уповноважених органів вимагайте надання документів, що підтверджують факт настання страхового випадку, а також опис причин і наслідків страхового випадку. ',
      faq_txt22: 'Які ліміти по договору КАСКО?',
      faq_txt23: 'Залежно від умов, які виставляє СК',
      faq_txt24: 'В якому випадку авто вважається знищеним?',
      faq_txt25: 'Кожна страхова компанія самостійно вирішує, в яких випадках можна визнати конструктивне знищення авто. Однак в правилах КАСКО більшості компаній зазначено, що тотальна загибель машини настає в наступних випадках: -Якщо вартість ремонту перевищує певний відсоток від страхової суми (зазвичай 60-80 відсотків). -Якщо немає технічної можливості відремонтувати автомобіль.',
    },
  });
  strings.setLanguage(props.locale);
  return (
    <section id="faq">
      <div className="container">
        <div className="faq-titblock">
          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item active">
              <a className="nav-link active" data-toggle="tab" href="#tab-1" role="tab">{strings.tab1}</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab-2" role="tab">{strings.tab2}</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab-3" role="tab">{strings.tab3}</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab-4" role="tab">{strings.tab4}</a>
            </li>
          </ul>
        </div>
        {/* Tab panes */}
        <div className="tab-content">
          <div className="tab-pane active p-3" id="tab-1" role="tabpanel">
            <div className="flex flex_j-space-between">
              <div className="img-block img-transform">
                <picture>
                  <source srcSet={imgPolisWebp} type="image/webp" />
                  <img src={imgPolis} alt="phone" />
                </picture>
                {/*<picture>*/}
                {/*  <source srcSet={imgW} type="image/webp" />*/}
                {/*  <img src={imgP} alt={imgP} />*/}
                {/*</picture>*/}
              </div>
              <div className="txt">
                {/*  <h2>{strings.title}</h2>
                <p>{strings.txt}</p>
                <ul className="ul-list">
                  <li><span className="mark" />{strings.list1}</li>
                  <li><span className="mark" />{strings.list2}</li>
                  <li><span className="mark" />{strings.list3}</li>
                </ul> */}
                <p>
                  {strings.what_txt}
                </p>
                <div className="btn-block">
                  <a
                    href="#"
                    className="btn btn-bg"
                    onClick={props.onScrollToComponent}
                  >
                    {strings.btn}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="tab-pane p-3" id="tab-2" role="tabpanel">
            <div className="flex flex_j-space-between">
              <div className="img-block img-transform">
                <picture>
                  <source srcSet={imgPolisWebp} type="image/webp" />
                  <img src={imgPolis} alt="phone" />
                </picture>
                {/*<picture>*/}
                {/*  <source srcSet={imgW} type="image/webp" />*/}
                {/*  <img src={imgP} alt={imgP} />*/}
                {/*</picture>*/}
              </div>
              <div className="txt">
                {/* <h2>{strings.title}</h2>
                <p>{strings.txt}</p>
                <ul className="ul-list">
                  <li><span className="mark" />{strings.list1}</li>
                  <li><span className="mark" />{strings.list2}</li>
                  <li><span className="mark" />{strings.list3}</li>
                </ul> */}
                <p>
                  {strings.how_txt}
                </p>
                <p><strong>{strings.how_txt2}</strong></p>
                <ul className="ul-list">
                  <li><span className="mark" />
                    {strings.step} 1:
                    <br />
                    {strings.step1}
                  </li>
                  <li><span className="mark" />
                    {strings.step} 2:
                    <br />
                    {strings.step2}
                  </li>
                  <li><span className="mark" />
                    {strings.step} 3:
                    <br />
                    {strings.step3}
                  </li>
                  <li><span className="mark" />
                    {strings.step} 4:
                    <br />
                    {strings.step4}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="tab-pane p-3" id="tab-3" role="tabpanel">
            <div className="flex flex_j-space-between flex_a-start">
              <div className="img-block">
                <div className="step step-1 flex flex_a-start flex_j-space-between">
                  <div>
                    <h3>{strings.step} 1</h3>
                    <p>{strings.step_txt1}</p>
                  </div>
                  <div>
                    <img src={car} alt="car" />
                    <img src={lamp} alt="lamp" />
                  </div>
                </div>
                <div className="step step-2 flex flex_a-start flex_j-space-between">
                  <div>
                    <h3>{strings.step} 2</h3>
                    <p>{strings.step_txt2}</p>
                  </div>
                  <div>
                    <img src={txt} alt="txt" />
                  </div>
                </div>
                <div className="step step-3 flex flex_a-start flex_j-space-between">
                  <div>
                    <h3>{strings.step} 3</h3>
                    <p>{strings.step_txt3}</p>
                  </div>
                  <div>
                    <img src={medical} alt="medical" />
                    <img src={police} alt="police" />
                    <img src={family} alt="family" />
                    <img src={witnesses} alt="witnesses" />
                  </div>
                </div>
                {/*<img src={imgPolis} alt={imgPolis} />*/}
                {/*<picture>*/}
                {/*  <source srcSet={imgW} type="image/webp" />*/}
                {/*  <img src={imgP} alt={imgP} />*/}
                {/*</picture>*/}
              </div>
              <div className="txt-dtp">
                <h2>{strings.tab3}</h2>
                <p>
                  <strong>При ДТП</strong>, {strings.dtp_txt1}
                </p>
                <p>
                  <strong>{strings.dtp_txt2}</strong> {strings.dtp_txt3}
                </p>
                <p>
                  <strong>{strings.dtp_txt4}</strong> {strings.dtp_txt5}
                </p>
                <p>
                  {strings.dtp_txt6}
                </p>
                <p>
                  <strong>{strings.dtp_txt7}</strong>{strings.dtp_txt8}
                </p>
              </div>
            </div>
          </div>
          <div className="tab-pane p-3" id="tab-4" role="tabpanel">
            <div className="flex flex_j-space-between">
              <div className="img-block img-transform">
                <picture>
                  <source srcSet={imgPolisWebp} type="image/webp" />
                  <img src={imgPolis} alt="phone" />
                </picture>

                {/*<picture>*/}
                {/*  <source srcSet={imgW} type="image/webp" />*/}
                {/*  <img src={imgP} alt={imgP} />*/}
                {/*</picture>*/}
              </div>
              <div className="txt tabs-accordion">
                <Accordion allowZeroExpanded>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {strings.faq_txt1}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        {strings.faq_txt2}
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {strings.faq_txt3}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        {strings.faq_txt4}
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {strings.faq_txt5}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        {strings.faq_txt6}
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {strings.faq_txt7}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        {strings.faq_txt8}
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {strings.faq_txt9}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        {strings.faq_txt10}
                        <br />
                        {strings.faq_txt11}
                        <br />
                        {strings.faq_txt12}
                        <br />
                        {strings.faq_txt13}
                        <br />
                        {strings.faq_txt14}
                        <br />
                        {strings.faq_txt15}
                        <br />
                        {strings.faq_txt16}
                        <br />
                        {strings.faq_txt17}

                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {strings.faq_txt18}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        {strings.faq_txt19}
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {strings.faq_txt20}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        {strings.faq_txt21}
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {strings.faq_txt22}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        {strings.faq_txt23}
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        {strings.faq_txt24}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        {strings.faq_txt25}
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InsuranceTitle;
